import { AppAreaConfig } from '@/funnels/@types'
import maleTaiChiYoga from './activity-male-tai-chi-yoga'
import femaleTaiChi from './activity-female-tai-chi'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-tai-chi',
	options: {
		userTags: ['tai_chi_walking'],
		userFlags: ['hasAccessToWalkingVideos'],
	},
	landing: {
		ids: ['loader-tai-chi', 'age-tai-chi'],
		route: {
			path: '/tai-chi',
			name: 'main-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-tai-chi-gender-selection',
		route: {
			path: '/tai-chi/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'tai-chi-survey',
		},
		slug: 'main-tai-chi',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiYoga },
				female: { appArea: femaleTaiChi },
			},
		},
	},
}

export default appAreaConfig
